import { render } from "./PokemonDetail.vue?vue&type=template&id=9e65bb2e&scoped=true"
import script from "./PokemonDetail.vue?vue&type=script&lang=js"
export * from "./PokemonDetail.vue?vue&type=script&lang=js"

import "./PokemonDetail.vue?vue&type=style&index=0&id=9e65bb2e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e65bb2e"]])

export default __exports__